module.exports = __webpack_public_path__ + "img/chips20.563879fc.png";